module.exports = __webpack_public_path__ + "static/media/Person4.f163df89.png";